import { StatModule } from "@/core/modules/stat/objects/StatModule";

import HandleCodeView from "./views/HandleCodeView.vue";

export const handleCode: StatModule = new StatModule("warehouse", "HandleCode", "warehouseStat", HandleCodeView);
